import { AppState } from '../../index';

export function getFavoriteGroupItems(state: AppState) {
   return state.wishlistItems;
}
